import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input  } from '@angular/core';
import { ICurrencyFormatter, Currencyformatters } from '../interfaces/ICurrencyFormatters';


@Component({
    selector: 'cu-download-link-cell-currency-renderer',
    template: `{{formattedValue}}`
  })

 
  export class currencyRenderer {
      params:any;
      public formattedValue:string = "";
      constructor( ) { 

      }
      
      public formatters:ICurrencyFormatter = Currencyformatters
      public currency = "USD";
      

      agInit(params:any): void { 
          this.params = params; 
          this.formattedValue = this.formatters[this.currency].format(this.params.data.balance); //String(this.params.data.Balance); 
     }
    


     refresh(params: any): void {
      this.params = params;

      // console.log("refreshPNL");
      // console.log(this.params.data);
      
          this.formattedValue = String(this.params.data.balance); 
       
       }

  }
  
  export type CellAction = (params:any) => void;